import { render, staticRenderFns } from "./ModuleManager.vue?vue&type=template&id=590b8e16&scoped=true"
import script from "./ModuleManager.vue?vue&type=script&lang=js"
export * from "./ModuleManager.vue?vue&type=script&lang=js"
import style0 from "./ModuleManager.vue?vue&type=style&index=0&id=590b8e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b8e16",
  null
  
)

export default component.exports